<template>
  <div class="header-wrap">
    <div class="header-title">橡树超级省钱卡月卡</div>
    <div class="header-desc">预计每月可省 1600 元</div>
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  setup() {},
});
</script>

<style lang="less" scoped>
// https://common-h5-dev.xiangshuheika.com/static/upload/202508184b519fffe53a1.png
.header-wrap {
  margin: 0 auto;
  margin-top: 18px;
  background: url("https://common-h5-dev.xiangshuheika.com/static/upload/202508184b519fffe53a1.png")
    no-repeat;
  background-size: 100% !important;
  width: 306px;
  height: 109px;
  position: relative;

  .header-title {
    font-weight: 500;
    font-size: 16px;
    color: #f5d2b3;
    position: absolute;
    top: 16px;
    left: 17px;
  }

  .header-desc {
    position: absolute;
    font-weight: 400;
    font-size: 10px;
    color: #f5d2b3;
    top: 76px;
    left: 17px;
  }
}
</style>
